import { render, staticRenderFns } from "./dashboardmain0308.vue?vue&type=template&id=9574a22a&scoped=true&"
import script from "./dashboardmain0308.vue?vue&type=script&lang=js&"
export * from "./dashboardmain0308.vue?vue&type=script&lang=js&"
import style0 from "./dashboardmain0308.vue?vue&type=style&index=0&id=9574a22a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9574a22a",
  null
  
)

export default component.exports